import { render, staticRenderFns } from "./BindSelect.vue?vue&type=template&id=5858f816&scoped=true"
import script from "./BindSelect.vue?vue&type=script&lang=js"
export * from "./BindSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5858f816",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5858f816')) {
      api.createRecord('5858f816', component.options)
    } else {
      api.reload('5858f816', component.options)
    }
    module.hot.accept("./BindSelect.vue?vue&type=template&id=5858f816&scoped=true", function () {
      api.rerender('5858f816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/dangao/brandlist/BindSelect.vue"
export default component.exports